import React from "react";
import { Check } from "lucide-react";
import { WHOLESALE_COMMODITIES } from "../../mock";

export default function StepCommodities({ selected, onToggle }) {
  return (
    <div data-testid="step-commodities">
      <h2 className="font-display text-3xl md:text-5xl font-light leading-[1.05] text-[#10271a]">
        What would you like to <em className="italic text-[#1f4a33]">trade?</em>
      </h2>
      <p className="mt-4 text-[#5e6b61] text-lg max-w-xl">Select one or more commodities. You'll set grades and volumes for each on the next step.</p>
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
        {WHOLESALE_COMMODITIES.map((c) => {
          const on = selected.includes(c.id);
          return (
            <button
              key={c.id}
              type="button"
              onClick={() => onToggle(c.id)}
              aria-pressed={on}
              data-testid={`commodity-option-${c.id}`}
              className={`group relative text-left rounded-3xl overflow-hidden border-2 transition-all duration-300 ${on ? "border-[#1f4a33] shadow-[0_24px_50px_-28px_rgba(16,39,26,0.6)]" : "border-transparent hover:border-[#1f4a33]/30"}`}
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img src={c.image} alt={c.name} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#10271a]/85 via-[#10271a]/20 to-transparent" />
                <div className="absolute bottom-5 left-6 right-6 flex items-end justify-between gap-4">
                  <div>
                    <p className="text-[#e9d9bf] text-[11px] tracking-[0.2em] uppercase">{c.origin}</p>
                    <h3 className="font-display text-3xl text-[#f6f1e7] mt-1 leading-none">{c.name}</h3>
                  </div>
                  <span className={`h-9 w-9 rounded-full flex items-center justify-center border-2 transition-colors ${on ? "bg-[#f6f1e7] border-[#f6f1e7] text-[#10271a]" : "border-[#f6f1e7]/60 text-transparent"}`}>
                    <Check size={18} />
                  </span>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
